export const changeArrayItemById = (array, changedItem) => array && array.map(
  (item) => item.id === changedItem.id ? changedItem : item
);